import * as Sentry from "@sentry/react-router";
import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  isRouteErrorResponse,
  useRouteError,
} from "react-router";

export default function App() {
  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <link rel="preconnect" href="https://cdn.shopify.com/" />
        <link
          rel="stylesheet"
          href="https://cdn.shopify.com/static/fonts/inter/v4/styles.css"
        />
        <Meta />
        <Links />
      </head>
      <body style={{ margin: 0 }}>
        <Outlet />
        <ScrollRestoration />
        <Scripts />
        <script
          src="https://cdn.shopify.com/shopifycloud/app-bridge.js"
          defer
        ></script>
        <script
          type="module"
          src="https://cdn.shopify.com/shopifycloud/polaris/web-components.js"
          defer
        ></script>
      </body>
    </html>
  );
}

export function ErrorBoundary() {
  const error = useRouteError();

  // Capture the error to Sentry
  Sentry.captureException(error);

  let message = "An unexpected error occurred";
  let details = "Please try again later";

  if (isRouteErrorResponse(error)) {
    message = error.status === 404 ? "Page not found" : `Error ${error.status}`;
    details = error.statusText || error.data?.message || details;
  } else if (error instanceof Error) {
    message = error.name;
    details = error.message;
  }

  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <title>{message}</title>
        <Meta />
        <Links />
      </head>
      <body style={{ margin: 0 }}>
        <div style={{ padding: "2rem", fontFamily: "system-ui, sans-serif" }}>
          <h1>{message}</h1>
          <p>{details}</p>
        </div>
        <Scripts />
      </body>
    </html>
  );
}
